import React, { Component } from 'react';

export class ItemSearch extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <>
                <div className="sublocation-search">
                    {
                        this.props.addingItem &&
                        <>
                            <div className="sublocation-header">
                                <h3>Adding Item to {this.props.sublocationName}</h3>
                            </div>
                            <br />
                        </>
                    }
                    <input autoFocus autocomplete="off" placeholder="Scan UPC" onChange={(event) => this.props.updateInputValue("userInput", event.target.value)} value={this.props.userInput} onBlur={() => { this.props.focusOnInput() }} id='upc-input' className='inventory-management-input'></input>
                    <button hidden onClick={(event) => this.props.lookupItemInfo()} id='item-lookup-submit' className='item-lookup-submit'>Submit</button>
                    {
                        this.props.addingItem &&
                        <div className="subloc-manage-buttons">
                            <button className="cancel-button" onClick={() => { this.props.cancelAddItem() }}>Cancel</button>
                        </div>
                    }
                </div>
            </>
        );
    }
}